import React from "react";

import { useAppSelector } from "store";
import { selectFootfallOverTimeMeasure } from "modules/customer/tools/location/footfallNew/footfallSlice";
import { FootfallMeasureType } from "modules/customer/tools/location/footfallNew/footfallMeasureType";
import { Typography } from "@material-ui/core";

const FootfallOverTimeTitle: React.FC = () => {
    const footfallMeasure = useAppSelector(selectFootfallOverTimeMeasure);
    const measureLabel = footfallMeasure === FootfallMeasureType.NumberOfVisits ? "visits" : "dwell time";

    return (
        <Typography variant="h6" component="div">
            Average monthly {measureLabel} per cell within the selected retail centre
        </Typography>
    );
};

export default FootfallOverTimeTitle;
